// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2-HwP","savePackageButton":"ClientWallet_savePackageButton__1A8c1"};